<div nz-row [nzGutter]="{ xs: 8, sm: 16, md: 24, lg: 32, xl: 32, xxl: 32 }">
  <div *ngFor="let item of formData | keyvalue: keepOrder; let i=index" nz-col nzSpan="12" [nzXs]="{ span: 24 }"
    [nzSm]="{ span: 24 }" [nzMd]="{ span: 24 }" [nzLg]="{ span: 12 }" [nzXl]="{ span: 12 }"
    [ngClass]="{'grey-bg' : (i % 4 === 0 || i % 4 === 1), 'white-bg' : (i % 4 === 2 || i % 4 === 3)}">
    <div *ngIf="item.key !== undefined" nz-row>
      <div nz-col nzSpan="12" class="bold" *ngIf="!useTranslator"> {{getLabelName(item.key)}} </div>
      <div nz-col nzSpan="12" class="bold" *ngIf="useTranslator"> {{item.key | translate}} </div>
      <div *ngIf="item.value?.value" nz-col nzSpan="12"><a (click)="item.value.link()">{{item.value.value | translate}}</a></div>
      <div *ngIf="!item.value?.value" nz-col nzSpan="12">{{item.value | translate}}</div>
    </div>
    <div nz-row>
      <div *ngIf="item.key === undefined" nz-col nzSpan="12">
        <div class="bold">{{'sez.financials.account.error' | translate}}</div>
      </div>
    </div>
  </div>
</div>
